import { Box, CircularProgress, Fade, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const quotes = [
    "Loading, please wait...",
    "Fetching your quotes...",
    "Almost there...",
];

export const LoaderDoubleLines = (params: { loading?: boolean }) => {
    const [quoteIndex, setQuoteIndex] = useState(0);

    useEffect(() => {
        const quoteInterval = setInterval(() => {
            setQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        }, 2000);

        return () => clearInterval(quoteInterval);
    }, []);

    const getLoadingBox = () => (
        <Box

            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
                zIndex: 1300,
                paddingTop: '120px',
            }}
        >
            <Box sx={{ position: 'relative', width: 150, height: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                <CircularProgress
                    size={150}
                    thickness={2}
                    sx={{
                        color: "primary.main",
                        position: 'absolute',
                        animation: 'spinClockwise 2.5s linear infinite',
                    }}
                />

                <CircularProgress
                    size={130}
                    thickness={2}
                    sx={{
                        color: "secondary.main",
                        position: 'absolute',
                        animation: 'spinCounterClockwise 2.5s linear infinite',
                    }}
                />

                <Typography
                    variant="body2"
                    sx={{
                        position: 'absolute',
                        textAlign: 'center',
                        width: '100px',
                        fontSize: '0.9rem',
                        color: '#555',
                        padding: '10px',
                    }}
                >
                    {quotes[quoteIndex]}
                </Typography>
            </Box>
        </Box>
    );

    return (<>
        {params.loading === true || params.loading === false ?
            <><Fade in={params.loading} timeout={250}>{getLoadingBox()}</Fade></> :
            getLoadingBox()}
    </>

    );
};
